"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCustomElement = exports.convertCustomElProps = void 0;
var react_1 = require("react");
var helpers_1 = require("./utils/helpers");
var convertCustomElProps = function (props, customMapping, preservedObjs) {
    if (customMapping === void 0) { customMapping = []; }
    if (preservedObjs === void 0) { preservedObjs = []; }
    return Object.keys(props)
        .filter(function (key) {
        return (function (keyFilter) { return typeof props[keyFilter] !== 'function'; }) &&
            !(props[key] instanceof Node) &&
            !(props[key] instanceof HTMLElement) &&
            !preservedObjs.includes(key);
    })
        .reduce(function (acc, key) {
        var _a, _b;
        var _c;
        var prop = props[key];
        var computedKey = ((_c = (0, helpers_1.mappedProp)(customMapping, key)) === null || _c === void 0 ? void 0 : _c.wcProp) || key;
        if ((0, helpers_1.isObjectOrArray)(prop))
            return __assign(__assign({}, acc), (_a = {}, _a[computedKey] = JSON.stringify(prop), _a));
        return __assign(__assign({}, acc), (_b = {}, _b[computedKey] = prop, _b));
    }, {});
};
exports.convertCustomElProps = convertCustomElProps;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var useCustomElement = function (props, customMapping, preservedObjs, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
reactRef) {
    if (customMapping === void 0) { customMapping = []; }
    if (preservedObjs === void 0) { preservedObjs = []; }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var ref = reactRef ? reactRef : (0, react_1.createRef)();
    (0, react_1.useLayoutEffect)(function () {
        var current = ref.current;
        if (!current)
            return;
        // Functions that are either passed as event listeners or class properties
        var fns = (0, helpers_1.getFns)(props, customMapping);
        (0, helpers_1.applyFns)(fns, current);
        // Objects that should be passed as class property instead of attributes
        var objs = (0, helpers_1.getPreservedObjs)(props, preservedObjs);
        objs.forEach(function (_a) {
            var key = _a.key, value = _a.value;
            return (current[key] = value);
        });
        // HTMLElements to be passed as class property
        var els = (0, helpers_1.getHTMLElements)(props);
        els.forEach(function (_a) {
            var key = _a.key, el = _a.el;
            return (current[key] = el);
        });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return function () {
            (0, helpers_1.removeEventListeners)(fns, current);
        };
    }, [customMapping, props, ref]);
    var customElementProps = (0, exports.convertCustomElProps)(props, customMapping, preservedObjs);
    return [customElementProps, ref];
};
exports.useCustomElement = useCustomElement;
//# sourceMappingURL=use-custom-element.js.map